import { trackEvent } from '../../_common/client/tracking';

export const trackStarAmountClickOnCrLandingPage = (starLink: HTMLElement) => {
    const numOfStars = starLink.dataset.numOfStars;
    const numOfReviews = starLink.dataset.numOfReviews;
    trackEvent({
        review_FilterReview: ['select'],
        review_FilterReviewStars: [numOfStars],
        review_ReviewCount: [numOfReviews],
    });
};
